import { render, staticRenderFns } from "./RetoursClosedTable.vue?vue&type=template&id=bd663df4&scoped=true&lang=true&"
import script from "./RetoursClosedTable.vue?vue&type=script&lang=js&"
export * from "./RetoursClosedTable.vue?vue&type=script&lang=js&"
import style0 from "./RetoursClosedTable.vue?vue&type=style&index=0&id=bd663df4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd663df4",
  null
  
)

export default component.exports